import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { Menu, MenuItem } from '@mui/material';
import Link from '@mui/material/Link';
import logo from '../../cbalogo.png';
import HomeIcon from '@mui/icons-material/Home';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const currentUser = JSON.parse(localStorage.getItem("currentUser"));

const pages = [
    {
        name: 'Administración',
        submenu: [
            { name: 'Nueva OT', url: '/ordenes' },
            { name: 'Listado OT', url: '/list-ordenes' },
            { name: 'Stock OTS', url: '/ots-list' },
            { name: 'Garantías', url: '/garantias' },
            // { name: 'Peajes', url: '/peajes' },
            { name: 'Funcionarios', url: '/funcionarios' }
        ]
    },
    {
        name: 'Buscar Serial',
        url: '/seriales'
    },
    {
        name: 'Logística',
        submenu: [
            { name: 'Stock de Materiales', url: '/stock' },
            { name: 'Nuevo Remito Materiales', url: '/remito' },
            { name: 'Listado Remitos(materiales)', url: '/remito-list' },
            { name: 'Movimientos de Materiales', url: '/movimientos-materiales' },
            { name: 'Catálogo Materiales', url: '/materiales' }
        ]
    },
    {
        name: 'Operativa',
        submenu: [
            { name: 'Herramientas', isHeader: true },
            { name: 'Stock Herramientas', url: '/herramientas-stock' },
            { name: 'Nuevo Remito Herram.', url: '/herramientas-remito' },
            { name: 'Listado Remitos Herram.', url: '/herramientas-remitos-list' },
            { name: 'Catálogo Herram.', url: '/herramientas' },
            { isDivider: true },
            { name: 'Asistencia', isHeader: true },
            { name: 'Listado de Asistencias', url: '/asistencia-list' },
            { name: 'Cargar Asistencia', url: '/asistencia' },
            { name: 'Cuadrillas', url: '/cuadrillas' }
        ]
    }
];

const pagesHuawei = [
    { name: 'Servicios', url: '/huawei/servicios' },
    { name: 'Obras', url: '/huawei/obras' },
    {
        name: 'Trabajos',
        submenu: [
            { name: 'Nuevo Trabajo', url: '/huawei/trabajo-add' },
            { name: 'Listado Trabajos', url: '/huawei/trabajos' }
        ]
    },
    {
        name: 'Logística Huawei',
        submenu: [
            { name: 'Remitos', isHeader: true },
            { name: 'Nuevo Remito', url: '/huawei/remito-add' },
            { name: 'Listado Remitos', url: '/huawei/remitos' },
            { isDivider: true },
            { name: 'Inventario', isHeader: true },
            { name: 'Materiales', url: '/huawei/materiales' },
            { name: 'Stock', url: '/huawei/stock' }
        ]
    },
    { name: 'Cuadrillas', url: '/huawei/cuadrillas' }
];

const pageAdmin = [
    {
        name: 'Gerencia',
        submenu: [
            { name: 'Pagos Cuadrillas', isHeader: true },
            { name: 'Producción Mensual', url: '/liquidacion' },
            { name: 'Combustible', url: '/combustible' },
            { name: 'Adelantos', url: '/adelantos' },
            { name: 'Descuentos', url: '/descuentos' },
            { isDivider: true },
            { name: 'Servicios y Precios', isHeader: true },
            { name: 'Catálogo de Servicios', url: '/servicios' },
            { name: 'Precios Base', url: '/prices' },
            // { name: 'Bonos', url: '/bonos' },
            { isDivider: true },
            { name: 'Estadísticas', isHeader: true },
            { name: 'Facturación', url: '/produccion-cuadrillas' },
            { name: 'Productividad', url: '/produccion-user' },
            { name: 'Estadísticas de garantías', url: '/estadisticas-garantias' },
            { isDivider: true },
            { name: 'Control de Acceso', isHeader: true },
            { name: 'Crear Usuario', url: '/register' },
            { name: 'Listado Usuarios', url: '/list-users' }
        ]
    }
];

const pageAdminCommon = [
    {
        name: 'Gerencia',
        submenu: [
            { name: 'Control de Acceso', isHeader: true },
            { name: 'Crear Usuario', url: '/register' },
            { name: 'Listado Usuarios', url: '/list-users' }
        ]
    }
];

const settings = ['Salir'];

function NavBar() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [anchorElMenus, setAnchorElMenus] = React.useState({});

    // Detectar si estamos en la sección Huawei
    const isHuaweiSection = window.location.pathname.startsWith('/huawei');
    const currentPages = isHuaweiSection ? pagesHuawei : pages;

    const getAdminPages = () => {
        const activeUser = JSON.parse(localStorage.getItem("currentUser")) || currentUser;

        if (isHuaweiSection) {
            return activeUser?.rol === 'admin' ? pageAdminCommon : [];
        }
        if (activeUser?.rol === 'admin') {
            return pageAdmin;
        }

        const userEmail = (activeUser?.email || activeUser?.user || activeUser?.usuario || '').toLowerCase();
        const userName = (activeUser?.userName || '').toLowerCase();
        const isCombustibleUser = ['ivan.riego@cbaconstruir.com.py', 'marco.barreto@cbaconstruir.com.py'].includes(userEmail);
        const isDescuentosUser = [
            'isabel.ortega@cbaconstruir.com.py',
            'fiorelha.sandoval@cbaconstruir.com.py',
            'isabelortega',
            'fiorelhasandoval',
            'isabel.ortega',
            'fiorelha.sandoval'
        ].some(item => userEmail.includes(item) || userName.includes(item));

        if (activeUser?.rol === 'write' || isCombustibleUser) {
            return [
                {
                    name: 'Gerencia',
                    submenu: [
                        { name: 'Estadísticas', isHeader: true },
                        { name: 'Estadísticas de garantías', url: '/estadisticas-garantias' },
                        { isDivider: true },
                        { name: 'Pagos Cuadrillas', isHeader: true },
                        { name: 'Combustible', url: '/combustible' },
                        { name: 'Descuentos', url: '/descuentos' }
                    ]
                }
            ];
        }

        if (isDescuentosUser) {
            return [
                {
                    name: 'Gerencia',
                    submenu: [
                        { name: 'Pagos Cuadrillas', isHeader: true },
                        { name: 'Descuentos', url: '/descuentos' }
                    ]
                }
            ];
        }
        return [];
    };

    const handleOpenNavMenu = (event) => setAnchorElNav(event.currentTarget);
    const handleCloseNavMenu = () => setAnchorElNav(null);

    const handleOpenUserMenu = (event) => setAnchorElUser(event.currentTarget);
    const handleCloseUserMenu = () => setAnchorElUser(null);

    const handleOpenMenu = (event, menuName) => {
        setAnchorElMenus((prev) => ({ ...prev, [menuName]: event.currentTarget }));
    };
    const handleCloseMenu = (menuName) => {
        setAnchorElMenus((prev) => ({ ...prev, [menuName]: null }));
    };

    const handleClickMenu = () => {
        localStorage.removeItem('currentUser');
        window.location.href = '/login';
    };

    return (
        <AppBar position="static" className='toolbar-app' sx={{ backgroundColor: '#d8d6d6' }}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <div>
                        <a href='/'><img decoding="async" width="50" height="30" src={logo} alt="Logo" loading="lazy" /></a>
                    </div>

                    {/* Botón Home para volver al hub */}
                    <Box sx={{ ml: 2 }}>
                        <Tooltip title="Volver al Hub">
                            <IconButton href="/hub" sx={{ color: '#333' }}>
                                <HomeIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>

                    {/* Mobile Menu */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="menu"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElNav}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{ display: { xs: 'block', md: 'none' } }}
                        >
                            {[
                                ...currentPages,
                                ...getAdminPages()
                            ].map((page) => (
                                page.submenu ? (
                                    <MenuItem key={page.name} onClick={(e) => handleOpenMenu(e, page.name)}>
                                        {page.name}
                                        <KeyboardArrowDownIcon sx={{ fontSize: '16px', marginLeft: '4px' }} />
                                        <Menu
                                            anchorEl={anchorElMenus[page.name]}
                                            open={Boolean(anchorElMenus[page.name])}
                                            onClose={() => handleCloseMenu(page.name)}
                                        >
                                            {page.submenu.map((subPage, idx) => {
                                                if (subPage.isDivider) {
                                                    return <hr key={idx} style={{ margin: '4px 0', borderColor: '#ccc', borderStyle: 'solid', borderWidth: '0.5px 0 0 0' }} />;
                                                }
                                                if (subPage.isHeader) {
                                                    return (
                                                        <MenuItem 
                                                            key={idx} 
                                                            disabled 
                                                            style={{ 
                                                                opacity: 0.85, 
                                                                fontWeight: 'bold', 
                                                                fontSize: '11px', 
                                                                color: '#1976d2', 
                                                                textTransform: 'uppercase',
                                                                letterSpacing: '0.5px',
                                                                paddingTop: '6px',
                                                                paddingBottom: '2px',
                                                                minWidth: '180px'
                                                            }}
                                                        >
                                                            {subPage.name}
                                                        </MenuItem>
                                                    );
                                                }
                                                return (
                                                    <MenuItem key={subPage.name || idx} onClick={() => { handleCloseMenu(page.name); handleCloseNavMenu(); }}>
                                                        <Link href={subPage.url} sx={{ textDecoration: 'none', color: '#000', fontSize: '13px' }}>{subPage.name}</Link>
                                                    </MenuItem>
                                                );
                                            })}
                                        </Menu>
                                    </MenuItem>
                                ) : (
                                    <MenuItem key={page.name} onClick={handleCloseNavMenu}>
                                        <Link href={page.url} sx={{ textDecoration: 'none', color: '#000' }}>{page.name}</Link>
                                    </MenuItem>
                                )
                            ))}
                        </Menu>
                    </Box>

                    {/* Desktop Menu */}
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        {[
                            ...currentPages,
                            ...getAdminPages()
                        ].map((page) => (
                            page.submenu ? (
                                <Box key={page.name} sx={{ position: 'relative' }}>
                                    <Button
                                        onClick={(e) => handleOpenMenu(e, page.name)}
                                        endIcon={<KeyboardArrowDownIcon sx={{ fontSize: '16px' }} />}
                                        sx={{ my: 2, color: 'black', marginLeft: '10px', fontSize: '12px' }}
                                    >
                                        {page.name}
                                    </Button>
                                    <Menu
                                        anchorEl={anchorElMenus[page.name]}
                                        open={Boolean(anchorElMenus[page.name])}
                                        onClose={() => handleCloseMenu(page.name)}
                                        sx={{
                                            '& .MuiPaper-root': {
                                                maxHeight: '450px',
                                                overflowY: 'auto'
                                            }
                                        }}
                                    >
                                        {page.submenu.map((subPage, idx) => {
                                            if (subPage.isDivider) {
                                                return <hr key={idx} style={{ margin: '4px 0', borderColor: '#ccc', borderStyle: 'solid', borderWidth: '0.5px 0 0 0' }} />;
                                            }
                                            if (subPage.isHeader) {
                                                return (
                                                    <MenuItem 
                                                        key={idx} 
                                                        disabled 
                                                        style={{ 
                                                            opacity: 0.85, 
                                                            fontWeight: 'bold', 
                                                            fontSize: '11px', 
                                                            color: '#1976d2', 
                                                            textTransform: 'uppercase',
                                                            letterSpacing: '0.5px',
                                                            paddingTop: '6px',
                                                            paddingBottom: '2px',
                                                            minWidth: '200px'
                                                        }}
                                                    >
                                                        {subPage.name}
                                                    </MenuItem>
                                                );
                                            }
                                            return (
                                                <MenuItem key={subPage.name || idx} onClick={() => handleCloseMenu(page.name)}>
                                                    <Link href={subPage.url} sx={{ textDecoration: 'none', color: '#000', width: '100%', fontSize: '13px' }}>{subPage.name}</Link>
                                                </MenuItem>
                                            );
                                        })}
                                    </Menu>
                                </Box>
                            ) : (
                                <Button key={page.name} href={page.url} sx={{ my: 2, color: 'black', marginLeft: '10px', fontSize: '12px' }}>
                                    {page.name}
                                </Button>
                            )
                        ))}
                    </Box>

                    {/* User Menu */}
                    <Box sx={{ flexGrow: 0 }}>
                        <Tooltip title="Menú">
                            <IconButton sx={{ p: 0 }} onClick={handleOpenUserMenu}>
                                <Avatar src="/broken-image.jpg" />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            sx={{ mt: '15px', padding: '20px' }}
                            anchorEl={anchorElUser}
                            open={Boolean(anchorElUser)}
                            onClose={handleCloseUserMenu}
                        >
                            <Typography color="textSecondary" sx={{ marginRight: '10px', padding: '10px' }}>{currentUser?.userName}</Typography>
                            {settings.map((setting) => (
                                <MenuItem key={setting} onClick={handleClickMenu}>
                                    <Typography textAlign="center">{setting}</Typography>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}

export default NavBar;
